/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-12 10:42:18
 * @LastEditors: K
 * @LastEditTime: 2022-09-26 14:13:49
 */

import { ADMIN_API_PREFIX, API_PREFIX } from './constant'
import { ContentType, MultiPartFormData, Request } from './request'
import {
  goTenantDataInitDoAsync,
  tenantDataInitAsync,
  YunDiDrugImportExcelAsync
} from "../compnents/importModal/purchaseModalSlice";
import {tenantDataInitParams} from "./tenant";
// 导入
export interface ImportExcelParams {
  file?: any
  tenantId?: string
  supplierId?: string
}

// 患者导入 excel
export function getpatientsExcelFn(params: ImportExcelParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/patient/log/importexcel`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}
// 患者诊断信息导入 excel
export function getpatientsDiagnosisExcelFn(
  params: ImportExcelParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/log/importexcel`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}

// 收费导入 excel
export function getchargeExcelFn(params: ImportExcelParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/payment/log/importexcel`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}

// 牙医管家诊断模板导入 excel
export function getDentistHousekeeperExcelFn(
  params: ImportExcelParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatmenttemplateitem/log/importexcel`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}
// 牙医管家诊断模板导入 excel
export function getHerbsExcelFn(params: ImportExcelParams): Request {
  return {
    url: params.tenantId ? `${API_PREFIX}/blade-potion/drugtenant/uploadExcel/importData` : `${API_PREFIX}/blade-potion/drugsupplier/uploadExcel/importData`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}

export function YunDiDrugImportExcel(params: ImportExcelParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/dataImport/yundi/drugimport`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}

export function YunDiTreatmentImportExcel(params: ImportExcelParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/dataImport/yundi/treatmentimport`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}

export function YunDiInventoryImportExcel(params: ImportExcelParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/dataImport/yundi/inventoryimport`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}

export function YunDiMaterialImportExcel(params: ImportExcelParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/dataImport/yundi/materialimport`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}
export function tenantDataInit(body: tenantDataInitParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/init/confirm`,
    method: 'POST',
    body,
  }
}
export function tenantDataSendSms(body: tenantDataInitParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/init/send`,
    method: 'POST',
    body,
  }
}
export function goTenantDataInitDo(body: tenantDataInitParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/init/batchDeleted`,
    method: 'POST',
    body,
  }
}
